var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Icon } from "@opala-ds/react";
import { cn } from "../utils/cn";
var channels = [
    {
        icon: {
            iconName: "MapPin",
            iconBg: "bg-[#EAF7FD]",
            iconColor: "text-[#69BEDC]",
        },
        title: "Canais presenciais",
        description: "Veja os canais que possuem atendimento presencial.",
        href: "".concat(process.env.CARTILHAS_URL_PRESENCIAL),
        buttonLabel: "Acessar lista",
    },
    {
        icon: {
            iconName: "WifiOff",
            iconBg: "bg-[#EAF7FD]",
            iconColor: "text-[#69BEDC]",
        },
        title: "Canais offline",
        description: "Veja os canais que possuem atendimento offline.",
        href: "".concat(process.env.CARTILHAS_URL_DIGITAL),
        buttonLabel: "Acessar lista",
    },
];
export default function ChannelsList() {
    function openChannel(href) {
        window.location.href = href;
    }
    return (_jsxs("div", __assign({ className: "flex flex-col gap-6" }, { children: [_jsxs("div", __assign({ className: "text-center flex flex-col md:space-y-0 space-y-6" }, { children: [_jsx("h2", __assign({ className: "text-[#262626] md:text-3xl font-bold text-xl text-balance" }, { children: "Canais de atendimento presencial e offline" })), _jsx("p", __assign({ className: "text-fg-moderate-default md:text-[14px] md:leading-relaxed tracking-wide text-base text-balance w-full text-center" }, { children: "Veja os canais de atendimento, os hor\u00E1rios de funcionamento e os telefones de contato." }))] })), _jsx("div", __assign({ className: "flex md:flex-row flex-col justify-center items-center gap-4" }, { children: channels.map(function (channel) { return (_jsxs("div", __assign({ className: "flex flex-col justify-between p-5 bg-[#F9FCFF] border border-[#E6E6E6] rounded-3xl md:max-w-64 md:w-auto w-full md:min-h-72 space-y-4 md:space-y-0" }, { children: [_jsx("div", __assign({ className: cn("flex items-center justify-center w-14 h-14 rounded-xl m-0", 
                            //eslint-disable-next-line
                            channel.icon.iconBg) }, { children: _jsx(Icon, { name: channel.icon.iconName, width: 32, height: 32, className: channel.icon.iconColor }) })), _jsx("h3", __assign({ className: "text-xl leading-normal font-bold text-fg-moderate-default text-balance" }, { children: channel.title })), _jsx("p", __assign({ className: "text-sm leading-snug text-fg-moderate-default text-balance" }, { children: channel.description })), _jsx(Button, __assign({ onClick: function () { return openChannel(channel.href); }, leftIcon: "ExternalLink", className: "w-full" }, { children: channel.buttonLabel }))] }), channel.title)); }) }))] })));
}
